/**
 * Helper function to check if a component returns null.
 *
 * This can be used by components to check if slots that do not use hooks are
 * implemented.
 *
 * @param Component
 *   The component to check.
 * @param props
 *   The props to pass to the component.
 * @returns
 *   True if the component returns null, false otherwise.
 */
export const isSlotEmpty = (Component, props) => {
  const result = Component(props);
  return result === null || result === undefined;
};
